module.exports = __webpack_public_path__ + "static/media/info_icon_vector.48f66b7c.svg";